import { Braces } from "lucide-react";
import { toast } from "sonner";

// Placeholders that resolve when a proposal send email goes out.
export const EMAIL_PLACEHOLDERS = [
  ["{client_name}", "Recipient name"],
  ["{client_first_name}", "Client first name"],
  ["{client_contact_name}", "Contact full name"],
  ["{client_trading_name}", "Trading name"],
  ["{client_legal_name}", "Legal name"],
  ["{client_company_number}", "Company number"],
  ["{client_email}", "Contact email"],
  ["{client_phone}", "Contact phone"],
  ["{client_industry}", "Industry"],
  ["{client_year_end}", "Year end"],
  ["{proposal_ref}", "Proposal reference"],
  ["{kind}", "\u201Cproposal\u201D or \u201Crenewal\u201D"],
  ["{owner_name}", "Prepared by"],
  ["{issue_date}", "Issue date"],
  ["{expiry_date}", "Expiry date"],
  ["{signing_deadline}", "Signing deadline"],
  ["{effective_date}", "Effective date"],
  ["{monthly_total}", "Monthly total (\u00a3)"],
  ["{link}", "Secure proposal link"],
  ["{message}", "Your personal message"],
];

// Clickable chips that insert a placeholder at the cursor of the last-focused field.
// `activeRef.current` must be { el, apply } — set on the field's onFocus.
export function PlaceholderBar({ activeRef, className = "" }) {
  const insert = (token) => {
    const a = activeRef.current;
    if (!a || !a.el) {
      toast.info("Click into the subject or message first, then pick a placeholder");
      return;
    }
    const el = a.el;
    const start = el.selectionStart ?? el.value.length;
    const end = el.selectionEnd ?? el.value.length;
    const cur = el.value;
    const next = cur.slice(0, start) + token + cur.slice(end);
    a.apply(next);
    requestAnimationFrame(() => {
      el.focus();
      const p = start + token.length;
      el.setSelectionRange(p, p);
    });
  };
  return (
    <div className={`flex flex-wrap items-center gap-1.5 ${className}`} data-testid="placeholder-bar">
      <span className="text-[11px] text-cass-slate flex items-center gap-1"><Braces className="w-3 h-3" />Insert:</span>
      {EMAIL_PLACEHOLDERS.map(([tok, label]) => (
        <button
          key={tok}
          type="button"
          onClick={() => insert(tok)}
          title={label}
          className="text-[11px] px-2 py-0.5 rounded-full border border-cass-teal/40 text-cass-navy hover:bg-cass-teal hover:text-white transition-colors"
          data-testid={`ph-chip-${tok.replace(/[{}]/g, "")}`}
        >
          {tok}
        </button>
      ))}
    </div>
  );
}
